module.exports = __webpack_public_path__ + "media/images/lb/530-3481da5e2d27013b7cd4a4999713e5ce.svg";